import $ from 'jquery';
import { post, get } from 'modules/api';
import jqueryToPromise from 'modules/utils/jqueryToPromise';

export const postPaymentCoupon = (paymentUuid, payload) =>
    post(`payment/mangopay/pay/${paymentUuid}/coupon`, payload);

/**
 * Get the coupons histories for a user.
 */
export const getHistories = () => get('payment/mangopay/coupon/histories');

export const getCouponBalance = currency => get(`payment/mangopay/coupon/balance/${currency}`);

/**
 *
 * @param {string} paymentUuid
 * @param {string} payload.card_provider
 * @returns Promise
 */
export const postCardRegister = (paymentUuid, payload) =>
    jqueryToPromise(
        $.post(`${process.env.API_ROOT}/payment/mangopay/pay/${paymentUuid}/card/register`, payload)
    );

export const deleteCard = (paymentUuid, cardId) =>
    jqueryToPromise(
        $.ajax(`${process.env.API_ROOT}/payment/mangopay/payment/${paymentUuid}/card/${cardId}`, {
            method: 'DELETE',
        })
    );

/**
 *
 * @param {*} payload.giftCardCode
 * @param {*} payload.orderId
 * @returns
 */
export const postCheckGiftCard = payload =>
    jqueryToPromise($.post(`${process.env.API_ROOT}/payment/mangopay/gift_cards/check`, payload));

/**
 *
 * @param {string} paymentUuid
 * @param {*} payload.method
 * @param {*} payload.coupon_amount
 * @param {*} payload.gift_card_code
 * @param {*} payload.charity_organisation_id
 * @param {*} payload.professionalData
 * @returns
 */
export const postPayWithDebit = (paymentUuid, payload) =>
    jqueryToPromise(
        $.post(`${process.env.API_ROOT}/payment/mangopay/pay/${paymentUuid}/debit`, payload)
    );

/**
 *
 * @param {string} paymentUuid
 * @param {*} payload.card_id
 * @param {*} payload.keep_card
 * @param {*} payload.coupon_amount
 * @param {*} payload.gift_card_code
 * @param {*} payload.charity_organisation_id
 * @param {*} payload.professionalData
 * @returns
 */
export const postPayWithCard = (paymentUuid, payload) =>
    jqueryToPromise(
        $.post(`${process.env.API_ROOT}/payment/mangopay/pay/${paymentUuid}/card`, payload)
    );

export const getPaymentStatus = (paymentUuid, payload) =>
    jqueryToPromise(
        $.get(`${process.env.API_ROOT}/payment/mangopay/pay/${paymentUuid}/status`, payload)
    );

export const getPaymentData = (paymentUuid, payload) =>
    jqueryToPromise(
        $.get(`${process.env.API_ROOT}/payment/mangopay/payment/${paymentUuid}`, payload)
    );

// ----------------------- Stripe -----------------------
export const getStripePaymentData = (paymentUuid, payload) =>
    jqueryToPromise(
        $.get(`${process.env.API_ROOT}/payment/stripe/payment/${paymentUuid}`, payload)
    );

export const getStripePaymentStatus = (paymentUuid, payload) =>
    jqueryToPromise(
        $.get(`${process.env.API_ROOT}/payment/stripe/payment/${paymentUuid}/status`, payload)
    );

export const initializeStripePayment = (paymentUuid, payload) =>
    jqueryToPromise(
        $.post(`${process.env.API_ROOT}/payment/stripe/payment/${paymentUuid}/pay`, payload)
    );

export const payWithStripeCoupon = (paymentUuid, payload) =>
    jqueryToPromise(
        $.post(`${process.env.API_ROOT}/payment/stripe/pay/${paymentUuid}/coupon`, payload)
    );
